export const MOCK_SESSION_ID = '7FC3A108-DF69-5E10-B767-6D2FB461B924';
export const AUTHENTICATED = 'authenticated';

export const DATALAYER_CONSTANT = {
  headerKeys: [
    'accept-language',
    'user-agent',
    'x-request-id',
    'x-service-id',
    'x-forwarded-host',
    'x-host',
    'x-xm-site-id',
    'x-lite-site',
    'x-request-uri',
    'x-request-host',
    'sec-fetch-user',
    'x-forwarded-for',
    'x-schema',
    'sec-fetch-mode',
    'x-forwarded-port',
    'sec-fetch-site',
    'sec-fetch-dest',
    'x-forwarded-proto',
    'referer',
    'forwarded',
    'messageid',
    'x-akamai-edgescape',
    'x-akamai-device-characteristics',
    'x-client-ip',
    'x-akamai-config-log-detail',
    'akamai-origin-hop',
    'digitalserviceswitch',
    'dtt',
  ],
};
// these constants are picked up from backend datalayer app
export const BRAND_CODES = {
  LUXURY: ['LC', 'XR', 'WH', 'RZ', 'EB', 'JW'],
  PREMIUM: ['MD', 'SI', 'WI', 'TX', 'DS', 'MC', 'BR', 'MV', 'GE', 'AK', 'DE', 'MG'],
  SELECT: ['AL', 'FP', 'CY', 'SH', 'PR', 'FI', 'AR', 'OX', 'XE', 'XF'],
  LONGER_STAYS: ['ER', 'RI', 'TS', 'EL', 'BA'],
};
export const AEP_COOKIE_PREFIX: string = 'kndctr';

export const HYBRID_CONFIG_CONSTANTS = {
  ROUTING_CONFIG: 'routingConfig',
  EXPERIENCE_SEGMENT: ['NOT Logged In'],
  EXPERIENCE_SEGMENT_AUTHENTICATED: ['Logged In'],
  MOCK_SESSION_ID: '7FC3A108-DF69-5E10-B767-6D2FB461B924',
};

export const PPV5_URL_FORMAT = 'einterface/v5';
export const PPV5_URL_REGEX = /\/einterface\/?[^?]*/;

export const DCA_CONSTANTS = {
  DCA: 'dca',
  gcv: 'AMCV_664516D751E565010A490D4C@AdobeOrg',
  MCMID_COOKIE: 'MCMID',
  orgId: '664516D751E565010A490D4C@AdobeOrg',
  trackingServer: 'metrics.marriott.com',
  trackingServerSecure: 'smetrics.marriott.com',
  marketingCloudServer: 'metrics.marriott.com',
  marketingCloudServerSecure: 'smetrics.marriott.com',
  authenticated: 'AUTHENTICATED',
  remembered: 'LOGGED_OUT',
};

export const DEFAULT_ACCEPT_LANGUAGE = 'en-US';
export const ACCEPT_LANGUAGE_TEST_REGEX = /^[a-z]{2}(-[A-Z]{2})?$/;

export const DATA_LAYER_ATTRIBUTES = {
  cookie_mi_site: '',
  request_id: '',
  browser_akamai_loc_country: '',
  env_date_time: '',
  env_is_prod: '', // AEM
  env_platform: '', // AEM
  env_server_id: '',
  env_site_id: '',
  page_requested_uri: '',
  page_url_query_string: '',
  sessionId: '',
  browser_akamai_loc_lat: '',
  browser_akamai_loc_long: '',
  browser_akamai_loc_city: '',
  cookie_personalization_guid: '',
  device_language_preferred: '',
  env_language: '',
  site_id: '',
  bot_cookie_info: '',
  browser_akamai_loc_state: '',
  previous_page: '',
};

export const DATA_LAYER_IGNORE_LIST = [
  'roomkey_api_key',
  'roomkey_api_version',
  'ensighten_settings',
  'rk_enabled',
  'rk_errorMessage',
  'rk_roomKeyBaseURL',
  'invokeFlushErrors',
  'rk_isProfileAuthenticated',
  'rk_currency',
  'rk_cList',
  'deals_special_offer_id',
];

// datalayer keys which can have empty values
export const DATA_LAYER_CAN_BE_NULL_LIST = ['browser_akamai_loc_city', 'previous_page'];

export const COOKIE_KEYS = {
  personalization: 'Personalization',
  miCnSite: 'MI_CN_SITE',
  miSite: 'MI_SITE',
  merchViewed: 'merchViewed',
  miVisitor: 'MI_Visitor',
  sessionID: 'sessionID',
  sLoginState: 's_loginState',
};

// keys in this object are datalayer keys and values are cookie names
export const PI_DATA = {
  sessionId: 'sessionID',
  session_jsession_id: 'sessionID',
  cookie_mi_visitor: 'sessionID',
};

export const CONSUMER_PROMOTION_CONFIG = {
  AVAILABLE_PROMOTION_OFFER_ID: 'MT004',
  NEW_PROMOTIONS_STATE_CODE: 'U',
  RECENT_PROMOTIONS_STATE_CODES: ['RMA', 'PEMA', 'PEPE', 'PENE'],
  UNAVAILABLE_PROMOTION_OFFER_ID: 'MT',
  YOUR_PROMOTIONS_STATE_CODES: ['RSP', 'RE', 'RNP', 'IP'],
};

export enum PROMOTION_TYPES {
  PROMOTION_NOT_DISPLAYED = 'promotionNotDisplayed',
  RECENT_PROMOTIONS = 'recentPromotions',
  YOUR_PROMOTIONS = 'yourPromotions',
  NEW_PROMOTIONS = 'newPromotions',
}

export enum RENDERER {
  BOOK = 'BOOK',
  SHOP = 'SHOP',
  COBRAND = 'COBRAND',
  OFFERS = 'OFFERS',
  ACCOUNT = 'ACCOUNT',
}

export enum LOYALTY_CONST {
  SUCCESS = 'Success',
  TRUE = 'true',
  FAILUTE = 'FAILURE',
  FALSE = 'false',
  INACTIVE = 'inactive',
}

type RENDERER_TYPE = keyof typeof RENDERER;

export type { RENDERER_TYPE };

export const PAGE_URI = {
  confirmReservationCancellation: '/reservation/confirmReservationCancellation',
  upcomingReservation: '/reservation/upcomingReservation',
  defaultSearch: '/search/default',
  reviewDetails: '/reservation/reviewDetails',
  availabilityCalendar: '/search/availabilityCalendar',
  upgradeReservation: '/reservation/upgradeReservation',
  modifyRLM: '/reservation/modifyRateListMenu',
  reservationConfirmation: '/reservation/confirmation',
  rlm: '/reservation/rateListMenu',
  default: '/default',
  loyaltyConvertPoints: '/loyalty/redeem/partner/convertPoints',
  loyaltyTransferPoints: '/loyalty/redeem/transfer-points/start',
};

export const AUTH_STATE = {
  loggedIn: 'authenticated',
  remembered: 'remembered',
  guest: 'unauthenticated',
};

export const BRAND_JSON_URL = '/content/dam/mi-aem-common-spa/rtp/serp-banner.json';

export const ACCOUNT_DATA_LAYER_PROPERTIES = {
  NEXT_PUBLIC_ORIENTATION_LANDSCAPE: 'Landscape',
  NEXT_PUBLIC_ORIENTATION_PORTRAIT: 'Portrait',
  NEXT_PUBLIC_PAGE_BREAKPT: 'Page Loaded on ',
};

// sensitive headers keys which should not be exposed to client side
export const HEADERS_BLOCKLIST = [
  // Authentication & Authorization (CRITICAL - Contains auth tokens/session data)
  'cookie', // Session cookies, auth tokens
  'authorization', // Bearer tokens, Basic auth credentials

  // Network & Proxy Information (Exposes internal network topology)
  'x-forwarded-for', // Client IP addresses through proxies
  'x-forwarded-host', // Original host header through proxies
  'x-forwarded-port', // Original port through proxies
  'x-forwarded-proto', // Original protocol (http/https)
  'x-forwarded-scheme', // Original URL scheme
  'x-real-ip', // Actual client IP address
  'x-client-ip', // Alternative client IP header
  'x-original-forwarded-for', // Original forwarded-for chain

  // Host Information (Can expose internal hostnames/domains)
  'host', // Target hostname
  'x-host', // Alternative host header
  'referer', // Referring page URL (may contain sensitive paths)

  // Tracking & Analytics (Contains user tracking identifiers)
  'traceparent', // W3C trace context parent
  'tracestate', // W3C trace context state
  'x-dynatrace', // Dynatrace monitoring headers
  'x-dynatrace-application', // Dynatrace application context
  'x-dynatrace-requeststate', // Dynatrace request state

  // CDN & Edge Computing (Exposes CDN configuration and routing)
  'x-akamai-edgescape', // Akamai geographic and network info
  'x-akamai-device-characteristics', // Akamai device detection data
  'x-akamai-config-log-detail', // Akamai configuration logging
  'akamai-origin-hop', // Akamai origin routing info
  'cdn-loop', // CDN loop detection
  'via', // Proxy chain information

  // Application-Specific Security Headers
  'x-misec', // Marriott-specific security header
  'phoenix', // Phoenix application header
  'hybridaemredirect', // AEM redirect header
  'user-agent', // User agent string (can contain PII)
  'x-schema', // Schema version information
];

export const EVENT_NAME = {
  PAGEVIEW: 'PAGEVIEW',
};
